import {
  ILandingCardLayoutLoadedDetail,
  LandingCardLayout
} from "../genericLanding/LandingCardLayout";
import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { moduletracking } from "../../Wyanoke/ModuleTracking";

export class SpecialtyLandingFeatured extends Component {
  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);
    window.addEventListener(
      LandingCardLayout.LandingCardLayoutLoadedEvent,
      ev =>
        this.updateFeatured(ev as CustomEvent<ILandingCardLayoutLoadedDetail>)
    );
  }

  private async updateFeatured(
    ev: CustomEvent<ILandingCardLayoutLoadedDetail>
  ): Promise<void> {
    const context = this._pageContext;
    if (!context) {
      throw new Error("No page context");
    }

    const featureHtml = ev.detail.featured;
    if (featureHtml && !($.isEmptyObject(featureHtml))
    && featureHtml.trim().length > 0) {
      this._element.innerHTML = featureHtml;
    }
    // const event = document.createEvent("Event");
    // event.initEvent("resize", true, false);
    // window.dispatchEvent(event);
    await context.componentFactory.loadComponents(this._element);
    moduletracking.AjaxTrackLinks(this._element, "Featured");
  }
}

ComponentFactory.registerComponent(
  "SpecialtyLandingFeatured",
  SpecialtyLandingFeatured
);
